<template>
    <footer class="footer no-print">
        <span>Ein Projekt von Claudio Brasser, Lehrperson</span>
        <nav aria-label="Fusszeile">
            <a href="mailto:claudio.brasser@gymneufeld.ch">
                <Mail aria-hidden="true" /> Kontakt
            </a>
            <a target="_blank" rel="noopener" href="https://buymeacoffee.com/cbrasser">
                <Coffee aria-hidden="true" /> Kaffee spendieren
            </a>
        </nav>
    </footer>
</template>

<script>
import { Coffee, Mail } from '@lucide/vue';

export default {
    name: 'SiteFooter',
    components: { Coffee, Mail },
}
</script>

<style scoped>
.footer {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: var(--s-1) var(--s-4);
    width: 100%;
    max-width: var(--page-max);
    margin: 0 auto;
    padding: var(--s-4) var(--gutter);
    font-size: var(--t-sm);
    font-weight: 700;
}

nav {
    display: flex;
    flex-wrap: wrap;
    gap: var(--s-1);
    margin-left: calc(-1 * var(--s-3));
}

a {
    display: inline-flex;
    align-items: center;
    gap: var(--s-2);
    min-height: var(--tap);
    padding: 0 var(--s-3);
    border-radius: var(--r-control);
    text-decoration: none;
    transition: background-color var(--dur-fast) var(--ease);
}

a:hover {
    background: rgb(255 255 255 / 0.45);
}

svg {
    width: 16px;
    height: 16px;
    stroke-width: 2.5;
}
</style>
